import React from 'react';

import { NudgeKebabMenu } from '@mesh.ai/rabbit';
import { addMonths, addWeeks } from 'date-fns';

import { sendSnoozedMeshRecommendsClickedEvent } from 'constants/mixpanelHelper';

import { useSnoozeNudgeCardMutation } from './dataHooks';
import { NudgeCard } from './types/nudgeCard';

const KebabMenu = ({
  ecaId,
  uiTemplate,
  nudgeIdType = 'ECA_ID',
  nudgeId,
}: Pick<NudgeCard, 'ecaId' | 'uiTemplate'> & { nudgeIdType?: 'ECA_ID' | 'NUDGE_ID'; nudgeId?: number }) => {
  const { mutate: snoozeNudgeCard } = useSnoozeNudgeCardMutation();

  const handleClick = (snoozeUpto: number, duration: string) => {
    sendSnoozedMeshRecommendsClickedEvent({
      eventProperties: {
        ecaId,
        source: 'HOME_PAGE',
        type: uiTemplate,
        snoozeValue: duration,
      },
    });
    snoozeNudgeCard({ ecaId, snoozeUpto, type: nudgeIdType, nudgeId });
  };

  return (
    <NudgeKebabMenu
      options={[
        {
          label: 'Snooze for 1 week',
          onClick: () => handleClick(addWeeks(new Date(), 1).getTime(), '1 week'),
        },
        {
          label: 'Snooze for 1 month',
          onClick: () => handleClick(addMonths(new Date(), 1).getTime(), '1 month'),
        },
        {
          label: 'Custom duration',
          type: 'custom',
          onClick: (weeks) => handleClick(addWeeks(new Date(), weeks).getTime(), `${weeks} weeks`),
          customCompProps: {
            label: 'Enter the number of weeks',
            buttonText: 'Snooze',
          },
        },
      ]}
    />
  );
};

export default KebabMenu;
